import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3yjdg6eew: FaireProductEntity = {
  token: "p_b3yjdg6eew",
  type: "product",
  name: "Lehua Blossom Honey - 5oz",
  brandName: "Wai Meli - Big Island Moonbow Farms L.L.C.",
  imageUrl:
    "https://cdn.faire.com/fastly/3d8c1219c9bb446ec6a87b94f58411f149c73c41bd657313181a88ad07d9d11e.png",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4f6f241d58110bab78287e1eee4c806550d9502b3a4c9093aea38230ca762d62.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
